/* Coaching Systems - Instant Training Quote calculator.
 * Port of the inline script on the WP page (instant-quote.php). Same markup,
 * IDs and UI flow; WooCommerce IDs / admin-ajax calls are replaced by Shopify
 * product data (section JSON config), the Shopify contact form (quote email)
 * and window.CSCart.add (checkout).
 */
(function () {
  'use strict';

  function boot() {
    var root = document.querySelector('[data-cs-iq]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var cfgEl = root.querySelector('[data-cs-iq-config]');
    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.error('Instant quote config error', e); return; }
    var COURSES = CFG.courses || [];
    var PACK = parseInt(CFG.pack_size, 10) || 25;

    var $ = function (id) { return document.getElementById(id); };
    var courseSelect = $('courseSelect');
    var planSelect = $('planSelect');
    var plansBox = $('plans');
    var instructorsField = $('instructorsField');
    var instructorsInput = $('instructors');
    var operatorsInput = $('operators');
    var mainFields = $('mainInputFields');
    var operatorFields = $('operatorInputFields');
    var contentWrap = $('contentWrap');
    var emailGate = $('emailGate');
    var gateLabel = root.querySelector('#quoteContent .gauge .label');
    var checkoutBtn = $('checkoutBtn');
    var anotherBtn = $('anotherQuoteBtn');
    var gateSubmit = $('gateSubmit');
    var quoteError = $('quoteError');

    var PLAN_DESC = {};
    planSelect.querySelectorAll('.plan-btn').forEach(function (b) {
      PLAN_DESC[b.getAttribute('data-plan')] = b.querySelector('.desc').textContent;
    });

    var state = { course: null, plan: null, variant: null, instructors: 0, operators: 0, learners: 0, total: 0, perOp: 0, lines: [] };
    var gateVisible = false;
    var unlocked = false;

    function toNumber(v, f) { var n = parseFloat(v); return isNaN(n) ? (f || 0) : n; }
    var fmt = new Intl.NumberFormat('en-US');
    function money(n) { return '$' + fmt.format(toNumber(n).toFixed(2)); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    /* Volume pricing: price_tiers [{min,max,price}] (dollars) are only trusted
       when the first tier matches the variant price; otherwise the flat variant
       price is used (some imported tiers belong to other products). */
    function validTiers(tiers, cents) {
      if (!Array.isArray(tiers) || !tiers.length) return null;
      var sorted = tiers.slice().sort(function (a, b) { return toNumber(a.min) - toNumber(b.min); });
      if (Math.round(toNumber(sorted[0].price) * 100) !== Math.round(toNumber(cents))) return null;
      return sorted;
    }
    function unitPrice(qty, tiers, cents) {
      var t = validTiers(tiers, cents);
      if (!t || qty <= 0) return toNumber(cents) / 100;
      for (var i = 0; i < t.length; i++) {
        var from = toNumber(t[i].min, 0), to = t[i].max ? toNumber(t[i].max) : 999999;
        if (qty >= from && qty <= to) return toNumber(t[i].price);
      }
      return toNumber(t[t.length - 1].price);
    }

    function course() { return state.course === null ? null : COURSES[state.course]; }
    function kitVariants(c) { return c && c.kit ? c.kit.variants.filter(function (v) { return v.available !== false; }) : []; }
    function planEnabled(c, plan) {
      if (!c) return false;
      if (plan === 'online') return !!c.online;
      if (plan === 'classroom') return kitVariants(c).length > 0;
      if (plan === 'hybrid') return kitVariants(c).length > 0 && !!c.online;
      return false;
    }

    function renderPlanButtons(c) {
      planSelect.innerHTML = '';
      ['online', 'classroom', 'hybrid'].forEach(function (plan) {
        var on = planEnabled(c, plan);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'plan-btn' + (on ? '' : ' disabled');
        b.setAttribute('data-plan', plan);
        b.disabled = !on;
        b.setAttribute('aria-disabled', String(!on));
        b.innerHTML = '<div class="name">' + plan.charAt(0).toUpperCase() + plan.slice(1) + '</div><div class="desc">' + esc(PLAN_DESC[plan] || '') + '</div>';
        planSelect.appendChild(b);
      });
    }

    function removeLearners() {
      var lf = $('learners_field');
      if (lf) lf.remove();
    }

    function resetCounts() {
      state.variant = null; state.instructors = 0; state.operators = 0; state.learners = 0;
      instructorsInput.value = '';
      operatorsInput.value = '';
      removeLearners();
      plansBox.innerHTML = '';
    }

    function setOperatorCopy() {
      var online = state.plan === 'online';
      var label = $('operatorsLabel'), note = $('operatorsNote');
      if (label) label.textContent = online ? CFG.notes.operators_label_online : CFG.notes.operators_label;
      if (note) note.textContent = online ? CFG.notes.operators_online : CFG.notes.operators;
    }

    function buildPlanHtml() {
      var c = course();
      plansBox.innerHTML = '';
      removeLearners();
      if (!c || state.plan === 'online') return;
      if (state.plan === 'hybrid') {
        var h2 = mainFields.querySelector('h2');
        var lf = document.createElement('div');
        lf.id = 'learners_field';
        lf.className = 'field';
        lf.innerHTML = '<label for="learners">Learners (online seats)</label><input id="learners" type="number" min="0" step="1" value="0">';
        h2.parentNode.insertBefore(lf, h2.nextSibling);
      }
      kitVariants(c).forEach(function (v, i) {
        var wrap = document.createElement('div');
        wrap.className = 'plan-btn';
        wrap.innerHTML = '<input type="radio" name="pa_media-type" value="' + v.id + '" id="var_' + v.id + '" data-price="' + v.price + '"' + (i === 0 ? ' checked' : '') + '> ' +
          '<label for="var_' + v.id + '"><div class="name">' + esc(v.title) + '</div></label>';
        plansBox.appendChild(wrap);
        if (i === 0) state.variant = v;
      });
    }

    function compute() {
      var c = course();
      var lines = [];
      var total = 0;
      if (c && state.plan) {
        if (state.plan !== 'online' && state.variant && state.instructors > 0) {
          var kp = unitPrice(state.instructors, c.kit.tiers, state.variant.price);
          var kt = kp * state.instructors;
          total += kt;
          lines.push({ id: 'instructor_info', name: state.variant.title, detail: '(' + state.instructors + ' instructors × $' + kp.toFixed(2) + ')', amt: kt,
            item: { id: state.variant.id, quantity: state.instructors } });
        }
        if (state.operators > 0) {
          if (state.plan === 'online' && c.online) {
            var op = unitPrice(state.operators, c.online.tiers, c.online.price);
            var ot = op * state.operators;
            total += ot;
            lines.push({ id: 'operator_info', name: 'Online Courses', detail: '(' + state.operators + ' operators × $' + op.toFixed(2) + ')', amt: ot,
              item: { id: c.online.variant, quantity: state.operators } });
          } else if (state.plan !== 'online' && c.book) {
            var packs = Math.ceil(state.operators / PACK);
            var bp = unitPrice(packs, c.book.tiers, c.book.price);
            var bt = bp * packs;
            total += bt;
            lines.push({ id: 'operator_info', name: 'Workbook Packs', detail: '(' + packs + ' packs × $' + bp.toFixed(2) + ')',
              sub: 'Covers ' + state.operators + ' operators · 1 workbook each', amt: bt,
              item: { id: c.book.variant, quantity: packs } });
          }
        }
        if (state.plan === 'hybrid' && state.learners > 0 && c.online) {
          var lp = unitPrice(state.learners, c.online.tiers, c.online.price);
          var lt = lp * state.learners;
          total += lt;
          lines.push({ id: 'learners_info', name: 'Online Seats', detail: '(' + state.learners + ' learners × $' + lp.toFixed(2) + ')', amt: lt,
            item: { id: c.online.variant, quantity: state.learners } });
        }
      }
      state.lines = lines;
      state.total = total;
      if (state.operators > 0) state.perOp = total / state.operators;
      else if (state.instructors > 0) state.perOp = total / state.instructors;
      else state.perOp = 0;
    }

    function render() {
      $('totalPrice').textContent = money(state.total);
      $('perOpPrice').textContent = money(state.perOp);
      var html = '';
      state.lines.forEach(function (l) {
        html += '<div id="' + l.id + '" class="line"><span>' + esc(l.name) + ' <small style="opacity:.7">' + esc(l.detail) + '</small>' +
          (l.sub ? '<br/><small>' + esc(l.sub) + '</small>' : '') + '</span><span class="amt">' + money(l.amt) + '</span></div>';
      });
      if (!html) html = '<div class="empty">Enter your fleet size to see a full breakdown.</div>';
      else html += '<div id="total_info" class="line" style="padding-top:10px;font-weight:700;"><span>TOTAL</span><span class="amt">' + money(state.total) + '</span></div>';
      $('breakdown').innerHTML = html;
    }

    function isComplete() {
      var c = course();
      if (!c || !state.plan || state.total <= 0) return false;
      if (state.plan === 'online') return state.operators > 0;
      var base = !!state.variant && state.instructors > 0 && (state.operators > 0 || !c.book);
      if (state.plan === 'hybrid') return base && state.learners > 0;
      return base;
    }

    function showGate() {
      if (gateVisible) return;
      gateVisible = true;
      contentWrap.classList.add('locked');
      emailGate.style.display = '';
      gateLabel.innerHTML = 'Your Quote <span style="color: #4CAF50; font-size: 14px;">✓ Ready</span>';
    }
    function hideGate() {
      if (!gateVisible) return;
      gateVisible = false;
      contentWrap.classList.remove('locked');
      gateLabel.innerHTML = 'Your Quote';
    }

    function update() {
      compute();
      render();
      var complete = isComplete();
      if (unlocked) {
        checkoutBtn.disabled = !complete;
        checkoutBtn.classList.toggle('enabled', complete);
      } else if (complete) {
        showGate();
      } else {
        hideGate();
      }
    }

    /* Events */
    courseSelect.addEventListener('change', function () {
      var v = courseSelect.value;
      state.course = v === '' ? null : parseInt(v, 10);
      state.plan = null;
      resetCounts();
      renderPlanButtons(course());
      instructorsField.style.display = '';
      setOperatorCopy();
      var c = course();
      var hasAny = c && (planEnabled(c, 'online') || planEnabled(c, 'classroom'));
      $('otherCourseNotice').style.display = c && !hasAny ? '' : 'none';
      mainFields.style.display = c ? '' : 'none';
      operatorFields.style.display = c ? '' : 'none';
      hideGate();
      update();
    });

    planSelect.addEventListener('click', function (e) {
      var b = e.target.closest('.plan-btn');
      if (!b || b.disabled || !course()) return;
      planSelect.querySelectorAll('.plan-btn').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      state.plan = b.getAttribute('data-plan');
      instructorsField.style.display = state.plan === 'online' ? 'none' : '';
      resetCounts();
      instructorsInput.value = 0;
      operatorsInput.value = 0;
      setOperatorCopy();
      buildPlanHtml();
      update();
    });

    root.addEventListener('change', function (e) {
      if (e.target.name === 'pa_media-type') {
        var c = course();
        var id = parseInt(e.target.value, 10);
        state.variant = kitVariants(c).filter(function (v) { return v.id === id; })[0] || null;
        update();
      }
    });

    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.id === 'instructors') state.instructors = Math.max(0, Math.floor(toNumber(t.value)));
      else if (t.id === 'operators') state.operators = Math.max(0, Math.floor(toNumber(t.value)));
      else if (t.id === 'learners') state.learners = Math.max(0, Math.floor(toNumber(t.value)));
      else return;
      update();
    });

    function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }

    function sendQuote(email) {
      var form = document.getElementById('cs-iq-contact');
      if (!form) return Promise.resolve();
      var c = course();
      var set = function (name, val) {
        var el = form.querySelector('[name="contact[' + name + ']"]');
        if (el) el.value = val;
      };
      set('email', email);
      set('Course', c ? c.label : '');
      set('Training type', state.plan || '');
      set('Instructor kit', state.plan !== 'online' && state.variant ? state.variant.title : '');
      set('Instructors', state.plan !== 'online' ? state.instructors : '');
      set('Operators', state.operators);
      set('Online learners', state.plan === 'hybrid' ? state.learners : '');
      set('Quote breakdown', state.lines.map(function (l) { return l.name + ' ' + l.detail + ': ' + money(l.amt); }).join(' | '));
      set('Quote total', money(state.total));
      return fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .catch(function (err) { console.warn('Quote email could not be sent', err); });
    }

    gateSubmit.addEventListener('click', function () {
      var email = $('gateEmail').value.trim();
      if (!email || !isValidEmail(email)) { $('gateError').style.display = 'block'; return; }
      $('gateError').style.display = 'none';
      var original = gateSubmit.textContent;
      gateSubmit.textContent = 'Sending...';
      gateSubmit.disabled = true;
      sendQuote(email).then(function () {
        unlocked = true;
        gateVisible = false;
        contentWrap.classList.remove('locked');
        emailGate.style.display = 'none';
        $('unlockedEmail').textContent = email;
        $('unlockedNote').style.display = 'block';
        gateSubmit.textContent = original;
        gateSubmit.disabled = false;
        anotherBtn.style.display = '';
        update();
      });
    });

    anotherBtn.addEventListener('click', function () {
      unlocked = false;
      $('gateEmail').value = '';
      $('unlockedNote').style.display = 'none';
      anotherBtn.style.display = 'none';
      checkoutBtn.disabled = true;
      checkoutBtn.classList.remove('enabled');
      emailGate.style.display = '';
      courseSelect.value = '';
      courseSelect.dispatchEvent(new Event('change'));
    });

    checkoutBtn.addEventListener('click', function () {
      if (!unlocked || !isComplete() || !window.CSCart) return;
      var items = state.lines.map(function (l) { return l.item; }).filter(function (i) { return i && i.id && i.quantity > 0; });
      var original = checkoutBtn.textContent;
      checkoutBtn.textContent = 'Adding to cart...';
      checkoutBtn.disabled = true;
      quoteError.style.display = 'none';
      $('confirmMsg').style.display = 'block';
      window.CSCart.add(items).then(function () {
        window.location.href = CFG.checkout_url || '/checkout';
      }).catch(function (err) {
        $('confirmMsg').style.display = 'none';
        quoteError.textContent = (err && err.message) || 'An error occurred. Please try again.';
        quoteError.style.display = 'block';
        checkoutBtn.textContent = original;
        checkoutBtn.disabled = false;
      });
    });

    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
